<template>
    <div id="app">
        <!--  header-->
        <div id="header">
            <div class="header_content">
                <div class="header_left">
                    <img src="./assets/logo.png" height="40" width="40"/>
                    <div class="title_box">
                        <div class="title">护眼天使</div>
                        <div class="stitle">守护你的眼健康</div>
                    </div>
                </div>
                <ul class="header_right">
                    <li>
                        <router-link to="/index">首页</router-link>
                    </li>
                    <li>
                        <router-link to="/beibeile">产品介绍</router-link>
                    </li>
                    <li>
                        <router-link to="/news">资讯</router-link>
                    </li>
                    <li>
                        <router-link to="/about">关于我们</router-link>
                    </li>
                </ul>
            </div>
        </div>


        <!--    content-->

        <router-view class="router"></router-view>


        <!--    footer-->
        <div id="footer">
            <div class="bottom_tab">Copyright © 2019 光朗(海南)生物科技有限责任公司</div>
            <div class="bottom_tab"> <a class="a" target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">琼ICP备2020003496号-3</a></div>
            <div class="bottom_tab"><span>互联网药品信息服务资格证书[（琼）-非经营性-2022-0010]</span></div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'index',
        components: {}
    }
</script>

<style scoped>
    body {
        margin: 0;
        padding: 0;
        touch-action: auto;
        max-width: 100vw;
    }
    .a{
        text-decoration: none;
        color: #a9a9a9;
    }
    .a:visited{
        color: #a9a9a9;
    }
    .a:hover {
        color: #a9a9a9;
    }

    #app {
        font-family: "Microsoft YaHei";
        background-color: #fff;
        margin: 0;
        padding: 0;
        width: 100%;
    }

    #header {
        /*margin: 0 auto;*/
        width: 100vw;
        box-shadow: 0 -2px #ececec inset;
        height: 60px;
        position: fixed;
        top: 0px;
        z-index: 111199;
        background-color: #fff;
        margin-right: calc(100% - 100vw);

    }

    .header_content {
        width: 50%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 60px;
    }

    .header_left {
        display: flex;
        align-items: center;
        height: 60px;
    }

    .header_right {
        height: 60px;
        display: flex;
        align-items: center;
        padding: 0;
        margin: 0;
    }

    .header_right li {
        text-decoration: none;
        list-style: none;
        margin-left: 25px;
    }

    .header_right a {
        text-decoration: none;
        color: #000;
        font-size: 16px;
        padding: 0 5px;
        display: inline-block;
        line-height: 56px;
        height: 56px;
        border-top: 4px solid #fff;
    }

    .title {
        font-size: 20px;
        color: #000;
        margin-left: 10px;
        font-weight: 600;
    }

    .stitle {
        font-size: 12px;
        color: #aaaaaa;
        margin-left: 10px;
    }

    .router {
        margin-top: 60px;

    }

    .router-link-active {
        height: 56px;
        line-height: 56px;
        border-top: 4px solid #31d2d6 !important;
    }

    #footer {
        margin-top: 10px;
        /*position: fixed;*/
        /*bottom: 0;*/
        /*left: 0;*/
        height: 90px;
        width: 95vw;
        background-color: #fff;
        z-index: 99;
        margin-right: calc(100% - 100vw);

    }

    .bottom_tab {
        height: 30px;
        width: 100%;
        /*background-color: #00a9ab;*/
        color: #a9a9a9;
        font-size: 12px;
        text-align: center;
        line-height: 30px;
        display: inline-block;
        text-decoration: none;
    }

    @media (max-width: 1050px) {
        .header_content {
            width: 95%;
        }


        .header_right li {
            margin-left: 5px;
        }

        .bottom_tab {
            font-size: 1.5vh;
            padding-left: 10px;
            padding-right: 10px;
        }
        #footer {
            position: fixed;
            bottom: 0;
            left: 0;
            height: 4vh;
            width: 100vw;
            background-color: #fff;
            z-index: 99;
            margin-right: calc(100% - 100vw);

        }
        .router {
            padding-bottom: 3.75vh;

        }
        .bottom_tab {
            height: 3.75vh;
            width: 100%;
            /*background-color: #00a9ab;*/
            color: #a9a9a9;
            font-size: 12px;
            text-align: center;
            line-height: 3.75vh;
            display: inline-block;
            text-decoration: none;
        }
    }

</style>
